import eventBus from "@/services/EventBus";

export default {
  methods: {
    showSidebar() {
      eventBus.$emit("page:showSidebar");
    }
  }
};
